import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { CalendarEvent } from '@/services/api-providers/CalendarServiceProvider';
import { CalendarDay } from '@/@types/Calendar';
import { eventLocalDate } from '@/helpers/calendarUtils';


export default /*#__PURE__*/_defineComponent({
  __name: 'CalendarAllDayRow',
  props: {
    events: null,
    days: null
  },
  emits: ["open-detail"],
  setup(__props: any) {

const props = __props as {
  events: CalendarEvent[];
  days: CalendarDay[];
}





const eventsByDay = computed(() => {
  const result: Record<string, CalendarEvent[]> = {};
  for (const day of props.days) {
    result[day.dateKey] = [];
  }
  for (const ev of props.events) {
    const dateKey = eventLocalDate(ev);
    if (result[dateKey]) {
      result[dateKey].push(ev);
    }
  }
  return result;
});

const hasEvents = computed(() => props.events.length > 0);

return { __sfc: true,props, eventsByDay, hasEvents }
}

})